// Mock data para AtivaJá Landing Page

export const siteData = {
  brand: {
    name: "AtivaJá",
    logo: "https://customer-assets.emergentagent.com/job_ativaja-auto/artifacts/kjqyzfuq_logo.png",
    tagline: "Automação • Sistemas • Escala"
  },
  
  whatsapp: {
    number: "5524993184232",
    message: "Olá, quero ativar meu negócio com o AtivaJá.",
    getLink: function() {
      return `https://wa.me/${this.number}?text=${encodeURIComponent(this.message)}`;
    }
  },
  
  hero: {
    title: "É só ativar. AtivaJá.",
    subtitle: "Automação inteligente para negócios que precisam rodar com menos esforço, mais controle e menos dependência de pessoas.",
    cta: "Ativar meu negócio"
  },
  
  about: {
    title: "O que é o AtivaJá?",
    description: "O AtivaJá é uma plataforma de automação operacional criada para estruturar negócios, eliminar tarefas manuais e manter processos funcionando de forma contínua.",
    highlights: [
      "Não somos agência.",
      "Não prestamos serviços isolados.",
      "Criamos sistemas que operam por você."
    ]
  },
  
  problems: {
    title: "Quando o negócio não está ativado, isso acontece:",
    items: [
      { icon: "Users", text: "Atendimento depende de pessoas" },
      { icon: "FileText", text: "Orçamentos manuais e lentos" },
      { icon: "Clock", text: "Falta de acompanhamento" },
      { icon: "Shuffle", text: "Processos confusos" },
      { icon: "MessageCircleOff", text: "Cliente sem retorno" },
      { icon: "UserX", text: "Dono sobrecarregado" }
    ],
    impact: "Se o seu negócio depende de você para tudo, ele ainda não está ativado."
  },
  
  solutions: {
    title: "O que muda depois da ativação",
    items: [
      { icon: "Bot", text: "Atendimento automático" },
      { icon: "Brain", text: "Orçamentos inteligentes" },
      { icon: "RefreshCw", text: "Follow-up contínuo" },
      { icon: "LayoutDashboard", text: "Organização centralizada" },
      { icon: "BarChart3", text: "Relatórios claros" },
      { icon: "ShieldCheck", text: "Menos falhas humanas" }
    ],
    impact: "O sistema continua. Você respira."
  },
  
  howItWorks: {
    title: "Como funciona a ativação",
    steps: [
      {
        number: "01",
        title: "Diagnóstico rápido",
        description: "Analisamos seus processos e identificamos gargalos."
      },
      {
        number: "02",
        title: "Ativação do sistema",
        description: "Configuramos automações, fluxos e painéis."
      },
      {
        number: "03",
        title: "Operação contínua",
        description: "O sistema roda de forma automática, com acompanhamento."
      }
    ],
    tagline: "Simples para você. Inteligente por trás."
  },
  
  targetAudience: {
    title: "Para quem o AtivaJá é ideal",
    idealFor: [
      "Pequenas e médias empresas",
      "Negócios físicos",
      "Prestadores de serviço",
      "Operações que querem escalar sem contratar mais gente"
    ],
    notFor: [
      "Quem busca improviso",
      "Quem não segue processo",
      "Quem só compara preço"
    ]
  },
  
  authority: {
    image: "https://customer-assets.emergentagent.com/job_ativaja-auto/artifacts/08dfqauk_tavi%20maia.png",
    imageAlt: "https://customer-assets.emergentagent.com/job_ativaja-auto/artifacts/zhkw8ij1_tavi%20maia%202.png",
    text: [
      "O AtivaJá não depende de pessoas.",
      "Depende de sistema.",
      "Cada projeto nasce com lógica, automação e monitoramento.",
      "Sem improviso. Sem gambiarra."
    ]
  },
  
  cta: {
    title: "Seu negócio pode operar melhor do que hoje.",
    subtitle: "A ativação é orientada, clara e sem compromisso inicial.",
    button: "Ativar agora"
  },
  
  footer: {
    copyright: "AtivaJá ©",
    tagline: "Automação • Sistemas • Escala",
    powered: "powered by AtivaJá"
  }
};
